<!--
================================================
Vue sur laquelle un utilisateur arrive en suivant
le lien dans l'email d'invitation dans l'appli.

Permet à l'utilisateur de définir ses prénoms, noms, et mot de passe

================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <outdoor-layout-comp>
        <div slot="AppContent">
            <signup-invit-comp></signup-invit-comp>
        </div>

    </outdoor-layout-comp>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->

<script>
    // @ is an alias to /src
    import OutdoorLayoutComp from '@/components/OutdoorLayoutComp.vue'
    import VueMetaMixin from "../mixins/VueMetaMixin.js";
    import SignupInvitComp from "../components/SignupInvitComp";

    export default {
        name: 'SignupInvitView',
        components: {
            SignupInvitComp,
            OutdoorLayoutComp,
        },
        mixins: [VueMetaMixin],
        metaInfo(){
            return this.setMeta(this.$t("metaTitleSignupInvitView"),this.$t("metaDescSignupInvitView"))
        },
        methods: {
        },
        created: function () {
        }
        //==========================================================
    }
</script>


<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<style lang="scss">
    /*ATTENTION : css non "scoped" s'applique à tout le html*/

    html {
    }

</style>

<style scoped lang="scss">


</style>
